// Dummy bill data matching the reference screenshots
export const generateDummyBill = () => {
  return {
    id: '1096901',
    bill_number: '1096901',
    invoice_number: null,
    bill_date: '2025-11-18',
    due_date: '2025-12-15',
    billing_period_start: '2025-10-21',
    billing_period_end: '2025-11-12',
    amount: 1182.39,
    amount_due: 1182.39,
    currency: 'USD',
    usage_amount: 129000,
    usage_unit: 'ccf',
    billing_period_start_2: '2025-10-09',
    billing_period_end_2: '2025-10-22',
    usage_amount_2: 92000,
    
    // Processing timeline
    collection_status: 'collected',
    processing_status: 'completed',
    parsed: true,
    parsed_at: '2025-11-20T05:17:00Z',
    created_at: '2025-11-19T00:00:00Z',
    assigned_at: '2025-11-20T12:57:00Z',
    
    // PDF URL
    pdf_url: null,
    csv_url: null,
    
    // Property and Account
    property: {
      id: 'prop-123',
      property_name: 'North Pointe Townhomes',
      property_type: 'residential',
      address: {
        street: '5215 Westwind Ave.',
        city: 'Cincinnati',
        state: 'OH',
        postal_code: '45246',
      },
    },
    
    utility_account: {
      id: 'acc-456',
      account_number: '3131842-2026813',
      commodity: 'water',
      vendor: {
        id: '36886',
        vendor_name: 'Butler County Water & Sewer',
        customer_service_phone: '5138873066',
      },
    },
    
    unit: {
      id: 'unit-789',
      unit_number: '101',
      unit_name: 'Unit 101',
    },
    
    // Bill blocks data
    bill_blocks: [
      {
        id: 'block-1',
        service_type: 'WATER',
        meter_id: '101139899',
        meter_number: '101139899',
        service_start_date: '2025-10-21',
        service_end_date: '2025-11-12',
        days_of_service: 22,
        current_read: 37,
        previous_read: 0,
        read_type: 'A',
        consumption: 37000,
        consumption_unit: 'gal',
        charges: 699.66,
        rate_plan: 'WATER',
        eru: 8,
        mult: 1000,
      },
      {
        id: 'block-2',
        service_type: 'WATER',
        meter_id: '29555',
        meter_number: '29555',
        service_start_date: '2025-10-09',
        service_end_date: '2025-10-22',
        days_of_service: 13,
        current_read: 3918,
        previous_read: 3826,
        read_type: 'A',
        consumption: 92000,
        consumption_unit: 'gal',
        charges: 482.73,
        rate_plan: 'WATER',
        eru: 8,
        mult: 1000,
      },
      {
        id: 'block-3',
        service_type: 'SEWER',
        meter_id: '29555',
        meter_number: '29555',
        service_start_date: '2025-10-21',
        service_end_date: '2025-11-12',
        days_of_service: 22,
        consumption: 172.45,
        consumption_unit: 'ccf',
        charges: 474.33,
        rate_plan: 'SEWER',
        virtual_account_id: '95112',
      },
    ],
    
    // Account activity/charges breakdown
    charges_breakdown: {
      previous_balance: 366.66,
      payments: [
        {
          date: '2025-11-12',
          amount: -366.66,
          description: 'Payment 11/12/2025 Thank you',
        },
      ],
      water_charges: [
        {
          description: 'Water Base Facility Charge',
          amount: 8.37,
        },
        {
          description: 'Water Consumption Charges 96000 @ $0.00481',
          amount: 461.76,
        },
        {
          description: 'Water Consumption Charges 33000 @ $0.00721',
          amount: 237.93,
        },
      ],
      sewer_charges: [
        {
          description: 'Sewer Base Facility Charge',
          amount: 4.53,
        },
        {
          description: 'Sewer Charges 96000 @ $0.00323',
          amount: 310.08,
        },
        {
          description: 'Sewer Charges 33000 @ $0.00484',
          amount: 159.72,
        },
      ],
      total_amount_due: 1182.39,
    },
    
    // Billing addresses
    billing_addresses: {
      bill_to: {
        address_line_1: 'SNS MANAGEMENT LLC',
        address_line_2: '11503 SPRINGFIELD PIKE SUITE 210',
        city: 'CINCINNATI',
        state: 'OH',
        postcode: '45246-3511',
        country: '',
      },
      remittance: {
        address_line_1: 'PO Box 933356',
        address_line_2: '',
        city: 'Cleveland',
        state: 'OH',
        postcode: '44193-0038',
        country: '',
      },
    },
    
    // Account details
    account_details: {
      virtual_account_id: '95112',
      service_address: '9500 TRIANGLE DR',
      service_zip: '45011',
      delivery_location: '3131842-2026813',
      vendor_type: 'Full Service',
      location_address: '5215 Westwind Ave.',
      location_description: 'North Pointe Townhomes',
      division: '-',
      next_read_date: '2025-12-09',
      prior_meter_reading: '1067946',
      estimated: false,
    },
    
    // Payment information
    payment_info: {
      payment_batch_id: null,
      payment_status: 'PENDING',
      marked_for_payment_date: '2025-11-19',
    },
    
    // Bill chain (related bills)
    bill_chain_id: '146768',
    related_bills: [
      {
        id: '1096901',
        bill_number: '1096901',
        invoice_date: '2025-11-18',
        amount: 1182.39,
        amount_due: 1182.39,
        due_date: '2025-12-15',
        days_since_previous: 29,
      },
      {
        id: '1067946',
        bill_number: '1067946',
        invoice_date: '2025-10-20',
        amount: 366.66,
        amount_due: 366.66,
        due_date: '2025-11-14',
        days_since_previous: 34,
      },
      {
        id: '1019229',
        bill_number: '1019229',
        invoice_date: '2025-09-16',
        amount: 430.98,
        amount_due: 430.98,
        due_date: '2025-10-13',
        days_since_previous: 152,
      },
      {
        id: '940759',
        bill_number: '940759',
        invoice_date: '2025-04-17',
        amount: 406.86,
        amount_due: 406.86,
        due_date: '2025-05-12',
        days_since_previous: 'First Bill',
      },
    ],
    
    // Account history (previous bills for same account)
    account_history: [
      {
        id: '1096901',
        bill_number: '1096901',
        billing_period_start: '2025-10-21',
        billing_period_end: '2025-11-12',
        days_of_service: 22,
        charges: 474.33,
        consumption: 172.45,
        consumption_unit: 'ccf',
      },
      {
        id: '1067946',
        bill_number: '1067946',
        billing_period_start: '2025-09-10',
        billing_period_end: '2025-10-09',
        days_of_service: 29,
        charges: 146.65,
        consumption: 58.82,
        consumption_unit: 'ccf',
      },
      {
        id: '1019229',
        bill_number: '1019229',
        billing_period_start: '2025-08-11',
        billing_period_end: '2025-09-10',
        days_of_service: 30,
        charges: 172.49,
        consumption: 69.51,
        consumption_unit: 'ccf',
      },
      {
        id: '940759',
        bill_number: '940759',
        billing_period_start: '2025-03-13',
        billing_period_end: '2025-04-11',
        days_of_service: 29,
        charges: 162.80,
        consumption: 65.50,
        consumption_unit: 'ccf',
      },
    ],
    
    // Prior bill for comparison
    prior_bill: {
      id: '1067946',
      bill_number: '1067946',
      invoice_date: '2025-10-20',
      due_date: '2025-11-14',
    },
    
    // Metadata
    notes: null,
    metadata: {},
    workspace_id: 'workspace-123',
  };
};

